const GET_STATIC_DATA = "infra/GET_STATIC_DATA";
const GET_STATIC_DATA_SUCCESS = "infra/GET_STATIC_DATA_SUCCESS";

export default {
  GET_STATIC_DATA,
  GET_STATIC_DATA_SUCCESS
};



// WEBPACK FOOTER //
// ./src/infraMonitor/staticData/types.js